import { sql } from "drizzle-orm";
import { index, integer, sqliteTable, text, uniqueIndex } from "drizzle-orm/sqlite-core";
// SQLite (Cloudflare D1) には ENUM が無いので TypeScript 側で narrow する。
// dokotoku.jp/mode/set が対象としているポイントサイト群を、hana 独自クローラを
// 持つ 5 サイト (moppy/hapitas/pointincome/chobirich/pointtown) と合わせて並置する。
// dokotoku は同一ブランドでも SKYFLAG / myChips / AppDriver などのオファーフィード
// 提供元ごとに別コードで分けているが、hana では brand 単位で集約する (同じオファーが
// 別 site として重複登録されるのを避けるため)。dokotoku 側の platform variant 情報は
// apps/crawler/src/sites/manifest.ts の dokotokuCodes / platforms に保持。
export const SITES = [
    // hana 独自クローラを持つ既存 5 サイト
    "moppy",
    "hapitas",
    "pointincome",
    "chobirich",
    "pointtown",
    // dokotoku.jp が対象としているブランド (46 件、上記 5 件と合わせて 51 サイト)
    "altema",
    "amefri",
    "au_point_program",
    "chance_it",
    "coincome",
    "d_job_smartphone_work",
    "d_point_market",
    "dot_money",
    "ecnavi",
    "entamenet",
    "fruitmail",
    "g_point",
    "gendama",
    "getmoney",
    "gmo_poikatsu",
    "infoq",
    "kensho_nyandaful",
    "kurashiru_reward",
    "line_brand_catalog",
    "mercari",
    "mikoshi",
    "mikoshi_mall",
    "mobareco_point_mall",
    "nifty_point_club",
    "poikatsu_club",
    "point_hiroba",
    "point_island",
    "point_land",
    "point_museum",
    "point_stadium",
    "pointier",
    "pokema_net",
    "poney",
    "ponta_bonus_park",
    "ponta_challenge",
    "powl",
    "rakuten_poikatsu_mission",
    "rakuten_point_mall",
    "rebates",
    "sugutama",
    "tamaru_mall",
    "trima",
    "v_point_mall",
    "value_point_club",
    "warau",
    "yattayo_net",
];
export const JOB_STATUSES = ["pending", "running", "done", "failed"];
// D1 は VECTOR 型を持たない。埋め込みは Cloudflare Vectorize に置き、
// D1 側では最終埋め込み時刻と使用モデルだけ持っておく (再埋め込み判定用)。
export const EMBEDDING_DIMENSIONS = 1024;
// SQLite 用 timestamp: text (ISO8601)。default に current_timestamp を入れる。
const timestampSql = sql `(current_timestamp)`;
export const offers = sqliteTable("offers", {
    id: integer("id").primaryKey({ autoIncrement: true }),
    site: text("site").$type().notNull(),
    externalId: text("external_id").notNull(),
    title: text("title").notNull(),
    description: text("description").notNull().default(""),
    pointText: text("point_text").notNull().default(""),
    url: text("url").notNull(),
    crawledAt: text("crawled_at").notNull().default(timestampSql),
    createdAt: text("created_at").notNull().default(timestampSql),
    updatedAt: text("updated_at").notNull().default(timestampSql),
    // 直近の埋め込み情報。Vectorize に投入したときだけ更新する。
    embeddedAt: text("embedded_at"),
    embeddingModel: text("embedding_model"),
}, (table) => [
    uniqueIndex("offers_site_external_id_idx").on(table.site, table.externalId),
    index("offers_title_idx").on(table.title),
    // 再埋め込み対象を探すクエリで使う
    index("offers_embed_state_idx").on(table.embeddingModel, table.embeddedAt),
]);
export const crawlJobs = sqliteTable("crawl_jobs", {
    id: integer("id").primaryKey({ autoIncrement: true }),
    site: text("site").$type().notNull(),
    status: text("status").$type().notNull().default("pending"),
    requestedBy: text("requested_by").notNull().default("system"),
    startedAt: text("started_at"),
    finishedAt: text("finished_at"),
    errorMessage: text("error_message"),
    attempts: integer("attempts").notNull().default(0),
    createdAt: text("created_at").notNull().default(timestampSql),
    updatedAt: text("updated_at").notNull().default(timestampSql),
}, (table) => [index("crawl_jobs_status_created_idx").on(table.status, table.createdAt)]);
export const affiliateTags = sqliteTable("affiliate_tags", {
    id: integer("id").primaryKey({ autoIncrement: true }),
    site: text("site").$type().notNull(),
    // 案件URLに付与するクエリ文字列 (例: "friend_code=abc123")
    tag: text("tag").notNull(),
    createdAt: text("created_at").notNull().default(timestampSql),
    updatedAt: text("updated_at").notNull().default(timestampSql),
}, (table) => [uniqueIndex("affiliate_tags_site_idx").on(table.site)]);
